import type { PaletteOptions } from "@mui/material/styles";

export const lightPalette: PaletteOptions = {
  mode: "light",

  primary: {
    main: "#116B64",
    light: "#4C9A93",
    dark: "#0C4A45",
    contrastText: "#ffffff",
  },

  secondary: {
    main: "#92703F",
    light: "#B89763",
    dark: "#6C532A",
    contrastText: "#ffffff",
  },

  background: {
    default: "#F2F7F6",
    paper: "#ffffff",
  },

  text: {
    primary: "#1F1F1F",
    secondary: "#4F4F4F",
  },

  divider: "#D5E1DF",

  success: {
    main: "#2E7D32",
  },

  warning: {
    main: "#F59E0B",
  },

  error: {
    main: "#D24545",
  },

  info: {
    main: "#1E88E5",
  },
};

export const darkPalette: PaletteOptions = {
  mode: "dark",

  primary: {
    main: "#4C9A93",
    light: "#7FC3BC",
    dark: "#116B64",
    contrastText: "#111",
  },

  secondary: {
    main: "#B89763",
    light: "#D8C097",
    dark: "#92703F",
    contrastText: "#111",
  },

  background: {
    default: "#0F1414",
    paper: "#1C2221",
  },

  text: {
    primary: "#F5F5F5",
    secondary: "#C4C8C7",
  },

  divider: "#2F3A39",

  success: {
    main: "#4CAF50",
  },

  warning: {
    main: "#FBBF24",
  },

  error: {
    main: "#EF5350",
  },

  info: {
    main: "#64B5F6",
  },
};
